<template>
  <div>
    <div class="h-full p-5 overflow-y-auto">
      <el-form
        ref="form"
        label-width="120px"
        class=""
        :model="adsMsg"
        :disabled="currentData.disabled"
        :rules="rules"
        @submit.native.prevent
      >
        <el-form-item
          label="广告组名称"
          prop="name"
        >
          <el-input
            v-model="adsMsg.name"
            placeholder="广告组名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="广告组状态">
          <el-switch
            v-model="adsMsg.status"
            active-text="开启"
            inactive-text="暂停"
            active-value="ENABLED"
            inactive-value="PAUSED"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <Keywords
        ref="keywordsComponent"
        v-model="adsMsg.groupCriterion"
        :enumConstants="enumConstants"
        :disabled="currentData.disabled"
        :bigData="adsMsg.campaignMsg"
        :createAdAccount="createAdAccount"
      />
    </div>
  </div>
</template>
<script>
import Keywords from '../../createSearchAds/components/Keywords.vue';
export default {
  props: {
    enumConstants: {
      type: Object,
      default: () => ({}),
    },
    currentData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    createAdAccount: {
      type: Object,
      default: () => ({}),
    },
    interestList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      adsMsg: {
        groupCriterion: {
          target: null,
          audience: null,
          keywordList: [],
        },
      },
      checkData: {
        bidMin: 0.01,
        bidMax: 1000000,
      },
      formData: {},
    };
  },
  components: {
    Keywords,
  },
  computed: {
    rules() {
      return {
        name: [{ required: true, message: '广告组名称不能为空' }],
        'groupCriterion.target.locations': [
          {
            required: true,
            message: '请选择地区',
          },
          {
            validator(rule, value, callback) {
              if (value.length == 0) {
                return callback(new Error('请选择地区'));
              }
              callback();
            },
            trigger: ['blur'],
          },
        ],
        bidAmount: [
          {
            validator: (rule, value, callback) => {
              if (value && (value < this.checkData.bidMin || value > this.checkData.bidMax)) {
                return callback(new Error(`出价不能高于${this.checkData.bidMax} 不能低于${this.checkData.bidMin}`));
              } else if (!value) {
                return callback(new Error(`出价不能高于${this.checkData.bidMax} 不能低于${this.checkData.bidMin}`));
              }
              callback();
            },
            message: `出价在${this.checkData.bidMin}～${this.checkData.bidMax}区间`,
            trigger: ['blur', 'change'],
          },
        ],
        bidStrategy: [{ required: true, message: '请选择竞价类型', trigger: ['change', 'blur'] }],
      };
    },
  },
  watch: {
    currentData: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.adsMsg = this.currentData;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async checkForm() {
      try {
        const validations = [this.$refs.form.validate()];

        // 只有当广告组目标出价组件存在时才校验
        // if (this.$refs.adsetBid && this.adsMsg.campaignBidStrategy !== 'AUTO') {
        //   validations.push(Promise.resolve(this.$refs.adsetBid.validate()));
        // }
        validations.push(Promise.resolve(this.$refs.keywordsComponent.validate()));
        const results = await Promise.all(validations);
        return results.every((result) => result === true);
      } catch (error) {
        return false;
      }
    },
    /**统一数据更新方法 */
    setAdMsgEmit(v) {
      Object.assign(this.adsMsg, v);
    },
  },
  created() {
    this.$nextTick(() => {});
  },
};
</script>
<style lang="scss" scoped></style>
